import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Mail, Phone, MessageCircle, MapPin } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';

const ContactUs: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us - Toppers Buddy | Class 10 Science Notes</title>
        <meta name="description" content="Contact Toppers Buddy for any queries about Class 10 Science short notes. Reach us via WhatsApp, email, or phone." />
      </Helmet>
      
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        
        <main className="flex-1 container px-4 md:px-6 py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-center mb-8">Contact Us</h1>
            
            <div className="bg-card rounded-xl border border-border p-8 shadow-sm">
              <p className="text-muted-foreground mb-8 text-center">
                Have questions about our Class 10 Science notes? We're here to help! Reach out to us through any of the following channels.
              </p>
              
              <div className="grid gap-6 md:grid-cols-2">
                <div className="flex items-start gap-4 p-4 rounded-lg bg-secondary/50">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
                    <MessageCircle className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">WhatsApp</h3>
                    <p className="text-sm text-muted-foreground">+91 7022174299</p>
                    <p className="text-xs text-muted-foreground mt-1">Fastest response</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 p-4 rounded-lg bg-secondary/50">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
                    <Mail className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Email</h3>
                    <p className="text-sm text-muted-foreground">toppersbuddy2@gmail.com</p>
                    <p className="text-xs text-muted-foreground mt-1">We reply within 24 hours</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 p-4 rounded-lg bg-secondary/50">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
                    <Phone className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Phone</h3>
                    <p className="text-sm text-muted-foreground">+91 7022174299</p>
                    <p className="text-xs text-muted-foreground mt-1">Mon-Sat, 10 AM - 6 PM</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 p-4 rounded-lg bg-secondary/50">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
                    <MapPin className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Location</h3>
                    <p className="text-sm text-muted-foreground">India</p>
                    <p className="text-xs text-muted-foreground mt-1">Serving students nationwide</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 p-4 bg-primary/5 rounded-lg border border-primary/20">
                <h3 className="font-semibold mb-2">Business Hours</h3>
                <p className="text-sm text-muted-foreground">
                  Monday to Saturday: 10:00 AM - 6:00 PM (IST)<br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>
        </main>
        
        <Footer />
        <WhatsAppButton />
      </div>
    </>
  );
};

export default ContactUs;
